import { LEPC_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Oregon State Portal": {
    parameters: {
      linkUrls: ["https://oregon.hazconnect.com/Account/Login.aspx"],
      staffInputs: {
        fees: false,
        documentTypes: {
          invoice: false,
          receipt: false,
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "OR",
  },
  "Oregon Portal Newly Not Reporting": {
    parameters: {
      staffInputs: {
        documentTypes: {
          proof: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "OR",
  },

  "Multnomah County LEPC (Portland Water Bureau)": {
    parameters: {
      linkUrls: [
        "https://www.notion.so/encamp/Portland-Water-Bureau-3d0a01df76364bd98eff686c24c5f626",
      ],
      includeLepcs: [
        {
          id: LEPC_IDS.OR.MULTNOMAH_COUNTY,
          name: "Multnomah County",
        },
      ],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "OR",
  },
};
